import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Typography from "../../../common-components/Typography";
import Action from "../../../common-components/Action";
import { font } from "../../../constants/font";
import { STATIC_PATH } from "../../../constants/config";
import content from "../../../constants/content";

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 0px;
  width: 100%;
  border-top: 1px solid #e5e7eb;
`;

const TabsHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 52px 20px 24px;
  width: 100%;
  @media only screen and (min-width: 769px) and (max-width: 1023px) {
    padding: 16px 24px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }
  @media only screen and (max-width: 767px) {
    flex-wrap: wrap;
    padding: 16px 16px 0px;
    gap: 17px;
  }
`;

const TabsHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  @media only screen and (max-width: 767px) {
    // width: 100%;
    // justify-content: center;
  }
`;

const TabsHeaderRight = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 767px) {
    justify-content: center;
    width: 100%;
  }

  .skip-btn-btn {
    @media only screen and (max-width: 767px) {
      display: none;
      justify-content: center;
      width: 92%;
      position: absolute;
      bottom: 24px;
      margin: 0px 24px;
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 0.5px 2px #00000029;
      border: 1px solid #d7dde0;
      border-radius: 8px;
      &:after {
        content: "";
        width: 100%;
        height: 1px;
        background: rgb(215, 221, 224);
        top: -15px;
        position: absolute;
        overflow: hidden;
      }
    }
  }
`;

const TabHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  position: relative;
  overflow: hidden;
  @media only screen and (max-width: 767px) {
    border-radius: 24px;
    background-color: #edeef2;
    margin: 19px auto 0px;
    display: none;
  }
`;

const TabsScrollWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 768px) and (max-width: 992px) {
    width: 320px;
    max-width: 320px;
  }
  @media (min-width: 993px) {
    overflow-x: unset;
    max-width: unset;
    width: unset;
  }
`;

const TabsContainer = styled.div`
  position: relative;
  display: flex;
  background-color: #edeef2;
  border-radius: 9999px;
  @media only screen and (max-width: 767px) {
    // flex-wrap: wrap;
  }
`;

const Indicator = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  transition: all 0.3s ease-in-out;
  left: ${(props) => props.left}px;
  width: ${(props) => props.width}px;

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

const TabButton = styled.button`
  position: relative;
  flex: 1;
  padding: 10px 14px;
  margin: 2px;
  text-align: center;
  white-space: nowrap;
  z-index: 10;
  color: ${(props) => (props.isActive ? "#313345" : "#4b5563")};
  border-radius: ${(props) => (props.isActive ? "9999px" : "20px")};
  font: ${(props) => (props.isActive ? font.boldBase : font.normalBase)};
  box-shadow: ${(props) =>
    props.isActive ? "0px 1px 3px #252A3C34" : "unset"};
  cursor: pointer;
  background: ${(props) => (props.isActive ? "#ffffff" : "transparent")};
  border: none;
  transition: all 0.3s;

  &:hover {
    background: ${(props) => (props.isActive ? "#fff" : "#DFE1E8")};
    border-radius: 40px;
  }

  @media only screen and (max-width: 767px) {
    background: ${(props) => (props.isActive ? "#ffffff" : "transparent")};
    width: auto;
    flex: 1;
  }
  @media (min-width: 768px) and (max-width: 992px) {
    width: 160px;
    flex: none;
  }
`;

const TabContent = styled.div`
  width: 100%;
  padding-bottom: 24px;
  height: 100%;
  @media only screen and (max-width: 767px) {
    padding-bottom: 0px;
    -webkit-overflow-scrolling: touch;
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 16px;
  background-color: #d7dde0;
  margin-left: 10px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f3f4f6;
  border: none;
  box-shadow: 0 1px 3px #252a3c14;
  cursor: pointer;
  position: relative;
  z-index: 20;
  margin: 19px 0px 0px;
  opacity: 1;
  transition: opacity 0.2s;
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;

const TabsBarWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

const UploadTabs = ({
  tabs,
  title,
  showEmptyProject,
  isUploading,
  onNewEmptyProject,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  const [isTablet, setIsTablet] = useState(() =>
    typeof window !== "undefined"
      ? window.innerWidth >= 768 && window.innerWidth <= 992
      : false
  );
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const tabRefs = useRef([]);
  const tabsContainerRef = useRef(null);
  const scrollWrapperRef = useRef(null);

  // Listen for resize to update isMobile and isTablet
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth <= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Update arrow visibility on scroll or tab change
  const updateArrows = () => {
    if (isTablet) {
      setShowLeftArrow(true);
      setShowRightArrow(true);
      return;
    }
    if (!isMobile) {
      setShowLeftArrow(false);
      setShowRightArrow(false);
      return;
    }
    const wrapper = scrollWrapperRef.current;
    if (!wrapper) return;
    setShowLeftArrow(wrapper.scrollLeft > 0);
    setShowRightArrow(
      wrapper.scrollLeft + wrapper.offsetWidth < wrapper.scrollWidth - 2
    );
  };

  useEffect(() => {
    if (!(isMobile || isTablet)) return;
    const wrapper = scrollWrapperRef.current;
    if (!wrapper) return;
    updateArrows();
    wrapper.addEventListener("scroll", updateArrows);
    // eslint-disable-next-line consistent-return
    return () => wrapper.removeEventListener("scroll", updateArrows);
  }, [isMobile, isTablet, tabs.length]);

  // Scroll to active tab on change (mobile/tablet)
  useEffect(() => {
    if (!(isMobile || isTablet)) return;
    const activeTabElement = tabRefs.current[activeTab];
    if (activeTabElement) {
      activeTabElement.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
    setTimeout(updateArrows, 200);
  }, [activeTab, isMobile, isTablet]);

  // Arrow click handlers
  const handleScrollLeft = () => {
    const wrapper = scrollWrapperRef.current;
    if (!wrapper) return;
    wrapper.scrollBy({ left: -100, behavior: "smooth" });
    // Select previous tab if possible
    setActiveTab((prev) => (prev > 0 ? prev - 1 : prev));
  };
  const handleScrollRight = () => {
    const wrapper = scrollWrapperRef.current;
    if (!wrapper) return;
    wrapper.scrollBy({ left: 100, behavior: "smooth" });
    // Select next tab if possible
    setActiveTab((prev) => (prev < tabs.length - 1 ? prev + 1 : prev));
  };

  const updateIndicator = () => {
    const activeTabElement = tabRefs.current[activeTab];
    const containerElement = tabsContainerRef.current;

    if (activeTabElement && containerElement) {
      const containerOffsetLeft = containerElement.getBoundingClientRect().left;
      const tabOffsetLeft = activeTabElement.getBoundingClientRect().left;
      const width = activeTabElement.offsetWidth;
      const left = tabOffsetLeft - containerOffsetLeft;
      setIndicatorStyle({ left, width });

      // Mobile auto-scroll
      if (window.innerWidth < 768) {
        activeTabElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  };

  useEffect(() => {
    setTimeout(updateIndicator, 50);
  }, [activeTab, tabs]);

  useEffect(() => {
    const handleResize = () => updateIndicator();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [activeTab, tabs]);

  return (
    <div style={{ height: "100%" }}>
      <TabsHeaderRow>
        {title && (
          <Typography
            content={title}
            font={font.bold_14}
            color="#313345"
            padding={isMobile ? "22px 0px 20px" : "4px 0px"}
          />
        )}
        <TabsHeaderLeft>
          <TabsBarWrapper>
            {(isMobile || isTablet) && showLeftArrow && (
              <ArrowButton
                onClick={handleScrollLeft}
                disabled={isMobile ? !showLeftArrow : false}
                aria-label="Scroll left"
                style={{ marginRight: 8 }}
              >
                <img src={`${STATIC_PATH}left-arr.svg`} alt="left-chevron" />
              </ArrowButton>
            )}
            <TabHeader>
              <TabsScrollWrapper ref={scrollWrapperRef}>
                <TabsContainer ref={tabsContainerRef}>
                  <Indicator
                    left={indicatorStyle.left}
                    width={indicatorStyle.width}
                  />
                  {tabs.map((tab, index) => (
                    <TabButton
                      key={tab.label}
                      ref={(el) => {
                        tabRefs.current[index] = el;
                      }}
                      onClick={() => setActiveTab(index)}
                      isActive={index === activeTab}
                    >
                      {tab.label}
                    </TabButton>
                  ))}
                </TabsContainer>
              </TabsScrollWrapper>
            </TabHeader>
            {(isMobile || isTablet) && showRightArrow && (
              <ArrowButton
                onClick={handleScrollRight}
                disabled={isMobile ? !showRightArrow : false}
                aria-label="Scroll right"
                style={{ marginLeft: 8 }}
              >
                <img src={`${STATIC_PATH}right-arr.svg`} alt="left-chevron" />
              </ArrowButton>
            )}
          </TabsBarWrapper>
        </TabsHeaderLeft>
        <TabsHeaderRight>
          {showEmptyProject ? (
            <>
              <Action
                text={content.EMPTY_PROJECT}
                font={font.boldBase}
                fontColor={isMobile ? "#1F222E" : "#313345"}
                width={"fit-content"}
                height={isMobile ? "40px" : "32px"}
                padding="0px 16px"
                onClick={onNewEmptyProject}
                borderColor={"#D7DDE0"}
                borderWidth={"1px"}
                marginTop="0px"
                marginBottom="0px"
                className="skip-btn-btn"
                background="#ffffff"
                activeBorderColor="#00BAFF"
                activeBorderWidth="1px"
                hoverColor={"#F0FBFE"}
                style={{ pointerEvents: isUploading ? "none" : "auto" }}
              />
              <VerticalDivider />
            </>
          ) : !isMobile ? <div style={{ width: '170px' }} /> : null}
        </TabsHeaderRight>
      </TabsHeaderRow>

      <TabsWrapper>
        <TabContent>
          {tabs[activeTab] ? tabs[activeTab].content : <p>No content.</p>}
        </TabContent>
      </TabsWrapper>
    </div>
  );
};

UploadTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
  showEmptyProject: PropTypes.bool,
  isUploading: PropTypes.bool,
  onNewEmptyProject: PropTypes.func,
};

UploadTabs.defaultProps = {
  title: null,
  showEmptyProject: false,
  isUploading: false,
  onNewEmptyProject: () => { },
};

export default UploadTabs;
